import axiosInstance from "@/utils/axios";
import { handleAxiosError } from "@/utils/helpers/handle-axios-errors";

export const checkUsername = async (username: string) => {
  try {
    const response = await axiosInstance.get(`/api/auth/check-username`, {
      params: { username },
    });
    return response;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
};

export const getBalance = async (address: string) => {
  try {
    const response = await axiosInstance.post<any>("/api/user/all-balance", {
      address,
    });
    return response;
  } catch (err) {
    handleAxiosError(err);
  }
};

export const ClaimTotalReward = async (address: string) => {
  try {
    return await axiosInstance.post<any>(
      "/api/user/get-all-rewards/" + address
    );
  } catch (error) {
    handleAxiosError(error);
  }
};

export const stoneRewards = async (
  address: string,
  chainId: number
): Promise<any> => {
  try {
    return await axiosInstance.get<any>(
      `/api/nft/staking/${address}/${chainId}`
    );
  } catch (error) {
    handleAxiosError(error);
  }
};

export const claimStoneRewards = async (
  address: string,
  chainId: number | string,
  oldTotalRewards: string | number
): Promise<any> => {
  try {
    return await axiosInstance.post<any>(
      `/api/nft/staking/${address}/claim/${chainId}`,
      {
        amount: oldTotalRewards,
      }
    );
  } catch (error) {
    handleAxiosError(error);
  }
};

export const getUserGlobalStats = async () => {
  try {
    const response = await axiosInstance.get<GlobalStatsData>(
      "/api/user/global-stats"
    );
    console.log("🚀 ~ getUserGlobalStats ~ response:", response);
    return { success: true, data: response };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    console.error("Error fetching user global stats:", error);
    return { success: false, error: errorMessage };
  }
};

export const getUserV2Transactions = async (
  userId: string | number,
  params: GetTransactionsParams = {}
): ApiResponse<PaginatedTransactionsData> => {
  try {
    const { from, to, page = 1, limit = 50 } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (from) queryParams.append("from", from);
    if (to) queryParams.append("to", to);

    const response = await axiosInstance.get<PaginatedTransactionsData>(
      `/api/user/${userId}/v2-transactions?${queryParams.toString()}`
    );
    return { success: true, data: response };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    console.error("Error fetching user V2 transactions:", error);
    return { success: false, error: errorMessage };
  }
};

export const getUserProfile = async (
  userId: string | number
): ApiResponse<UserProfileData> => {
  try {
    const response = await axiosInstance.get<UserProfileData>(
      `/api/user/v2-profile/${userId}`
    );
    return { success: true, data: response };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    console.error("Error fetching user profile:", error);
    return { success: false, error: errorMessage };
  }
};

export const claimNFTPoints = async (): ApiResponse<ClaimPointsResponse> => {
  try {
    const response = await axiosInstance.post<ClaimPointsResponse>(
      "/api/nft/claim-points"
    );
    return { success: true, data: response };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    console.error("Error claiming NFT points:", error);
    return { success: false, error: errorMessage };
  }
};

export const getNFTRewardsStatus = async (
  userId: string | number
): ApiResponse<RewardsStatus> => {
  try {
    const response = await axiosInstance.get<RewardsStatus>(
      `/api/nft/user/${userId}/rewards/status`
    );
    return { success: true, data: response };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    console.error("Error getting NFT rewards status:", error);
    return { success: false, error: errorMessage };
  }
};

export const canClaimNFTPoints = async (): ApiResponse<RewardsStatus> => {
  try {
    const response = await axiosInstance.get<RewardsStatus>(
      "/api/nft/can-claim-points"
    );
    return { success: true, data: response };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    console.error("Error checking if NFT points can be claimed:", error);
    return { success: false, error: errorMessage };
  }
};

export const getItemDetails = async (id: string) => {
  try {
    if (!id) {
      throw new Error('Item ID is required');
    }
    const response = await axiosInstance.get<ItemDetailsResponse>(`/api/blazbob/nft/${id}`);
    return response as any;
  } catch (error) {
    console.error('Error fetching item details:', error);
    handleAxiosError(error);
    throw error;
  }
};

export const getRecentTransactions = async (params: {
  page: number;
  limit: number;
  chainId?: string;
  moduleName?: string;
  transfer?: string;
}) => {
  try {
    const response = await axiosInstance.get<any>('/api/transaction', { params });
    return response as any;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
};
